import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";
import {
  grayScale,
  intellipick,
  mBody1,
  mBody2,
  mHeader1,
  mTitle1,
  swc,
  wBody1,
  wBody2,
  wHeader2,
  wTitle1,
} from "@teamsparta/design-system";

export const Wrapper = styled.div`
  width: 100%;
  padding: 80px 0;

  ${DESKTOP} {
    max-width: 1152px;
    margin: 0 auto;
    padding: 120px 0;
  }
`;

export const Titile = styled.h2`
  width: calc(100% - 32px);
  ${mHeader1}
  color: ${grayScale.gray100};
  margin: 0 auto 40px auto;

  ${DESKTOP} {
    max-width: 1152px;
    ${wHeader2}
    color: ${grayScale.gray100};
    margin: 0 0 60px;
  }
`;

export const Advantages = styled.section`
  width: calc(100% - 32px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${DESKTOP} {
    gap: 60px;
    margin: 0;
  }
`;

export const AdvantageWrapper = styled.section`
  display: flex;
  flex-direction: column;
  ${DESKTOP} {
    flex-direction: row;
  }
`;

export const Number = styled.small`
  width: 24px;
  height: 24px;
  ${mBody1}
  color: ${swc.blue};
  background-color: ${intellipick.blue10};
  padding: 2px 8px;
  border-radius: 8px;

  ${DESKTOP} {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${wBody1}
    color: ${swc.blue};
    padding: 0;
    margin-right: 20px;
  }
`;

export const Advantage = styled.h3`
  ${mTitle1}
  color: ${grayScale.gray90};
  margin: 16px 0 10px;

  ${DESKTOP} {
    ${wTitle1}
    color: ${grayScale.gray90};
    line-height: 100%;
    margin: 0 0 10px;
  }
`;

export const Desc = styled.p`
  ${mBody2}
  color: ${grayScale.gray80};

  ${DESKTOP} {
    ${wBody2}
    color: ${grayScale.gray80};
  }
`;
